export default __webpack_public_path__ + "static/media/codingame.3eb7ac5a.webp";